<mat-toolbar color="primary">
    <h5>{{'PET_MERGED' | translate}}</h5>
</mat-toolbar>
<div class="mdc-p-3 ">
    <p class="mat-text-secondary">{{'SUCCESSFUL_PET_MERGE' | translate}}</p>
    <button mat-raised-button (click)="redirect()" color="accent">{{'VIEW_MERGED_PROFILE' | translate}}</button>
</div>